/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateProjectApplicationDto
 */
export interface CreateUpdateProjectApplicationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProjectApplicationDto
     */
    applicationType: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateProjectApplicationDto
     */
    applicationVerification: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateProjectApplicationDto
     */
    applicationMessage: string;
}

/**
 * Check if a given object implements the CreateUpdateProjectApplicationDto interface.
 */
export function instanceOfCreateUpdateProjectApplicationDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "applicationType" in value;
    isInstance = isInstance && "applicationVerification" in value;
    isInstance = isInstance && "applicationMessage" in value;

    return isInstance;
}

export function CreateUpdateProjectApplicationDtoFromJSON(json: any): CreateUpdateProjectApplicationDto {
    return CreateUpdateProjectApplicationDtoFromJSONTyped(json, false);
}

export function CreateUpdateProjectApplicationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateProjectApplicationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'applicationType': json['applicationType'],
        'applicationVerification': json['applicationVerification'],
        'applicationMessage': json['applicationMessage'],
    };
}

export function CreateUpdateProjectApplicationDtoToJSON(value?: CreateUpdateProjectApplicationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'applicationType': value.applicationType,
        'applicationVerification': value.applicationVerification,
        'applicationMessage': value.applicationMessage,
    };
}

